export default "__VITE_ASSET__CI$$vEE2__"